import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function httpGetTopic(data) {
  const { searchKey, searchText } = data;
  const url = `${API_BASE_URL}/autocomplete?key=${searchKey}&term=topics&filter=${searchText}`;
  return request({
    url,
    method: "get",
  });
}

export async function httpGetAllTopics(data) {
  const url = `${API_BASE_URL}/autocomplete`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function httpDeleteTopic(data) {
  const { key, value } = data;
  const url = `${API_BASE_URL}/autocomplete/${key}?term=topics&value=${value}`;
  return request({
    url,
    method: "delete",
  });
}
